module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Navigation/Arrow-to-right-b7194f2e0c2dac7704e2d954b91be35a.svg";